// @ts-nocheck
/* eslint-disable */
export const removeIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9.5" stroke="#EDEFF1"/><rect width="8.333" height="1.667" x="5.833" y="9.167" fill="currentColor" rx=".833"/></svg>`,
    name: 'remove' as const
};